import { createFileRoute, Link } from "@tanstack/react-router";
import { Door, DoorActions, DoorButton, DoorText } from "@optymyse/suite-ui";
import { strings } from "../lib/strings";
import { PageTitle } from "../lib/title";

/**
 * Where the sign-in callback sends a person of a region Steer does not serve yet: one Impa has added
 * before Steer has a store there (SERVED_REGIONS, src/shared/schemas/region.ts). Nothing about them was
 * written; the suite's door only says why they are not in.
 */
function RegionUnavailablePage() {
  return (
    <Door product="steer" title={strings.auth.regionUnavailable.title} pip="locked">
      <PageTitle name={strings.auth.regionUnavailable.title} />
      <DoorText>{strings.auth.regionUnavailable.body}</DoorText>
      <DoorActions>
        <DoorButton asChild variant="quiet">
          <Link to="/">{strings.auth.regionUnavailable.back}</Link>
        </DoorButton>
      </DoorActions>
    </Door>
  );
}

export const Route = createFileRoute("/unavailable")({ component: RegionUnavailablePage });
